const currencyFormatter = (number, locale = 'en-US', currency = 'USD', precision = 2) => {
  const numberToFormat = number ? number.toString() : '0';
  const cf = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  });
  const onlyNums = numberToFormat.replace(/[^\d.]/g, '') || '0';
  return cf.format(onlyNums);
};

export default currencyFormatter;
